// BROWSER CHECK //
export const isBrowser = (typeof window !== 'undefined');